interface ICollapseIconProps {
  color?: string;
}

/**
 * Two arrows pulling together, down-left and up-right: "give the screen back".
 * Mirrors {@link ExpandIcon} so the toggle reads as one control.
 */
export const CollapseIcon = ({ color = "#fff" }: ICollapseIconProps) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 10H20M20 10V4M20 10L13 3M10 14H4M4 14V20M4 14L11 21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
